module.exports = "https://la-static.vkplay.ru/promo/newstart/img/berserker.ee9ac7be.png";